<template>
    <div>
        <div class="lineChart" :id=cId :style="customerStyle"></div>
    </div>
</template>

<script>
export default {
    props: {
        cId: {
            type: String,
            default: ''
        },
        chartData: {
            type: Object,
            default: null
        },
        customerStyle: String,
        unit: String
    },
    setup() {
        const myChart = null
        return {
            myChart
        }
    },
    methods: {
        initChart(data) {
            setTimeout(() => {
                this.drawChart(data)
            },100)
        },
        drawChart(data) {
            if (this.myChart != null) {
                //如果非初始化，则释放画布，以免造成重复加载
                this.myChart.dispose()
            }
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$root.$echarts.init(document.getElementById(this.cId))
            this.myChart = myChart

            // 指定图表的配置项和数据
            const option = {
                color: ['#F6921E', '#00D6E1'],
                grid: {
                    top: 60,
                    bottom: 50,
                    left: 70,
                    right: 30
                },
                legend: {
                    data: ['需求量', '服务量'],
                    left: '70',
                    top: '20',
                    textStyle: {
                        color: '#00c6fc'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        color: '#060D2A'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: data.name,
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: 'rgba(0,214,225,0.61)'
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        },
                        rotate: 50
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#00D6E1'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(0,214,225,0.61)'
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 14
                        }
                    },
                    minInterval: 1
                },
                series: [{
                    data: data.data0,
                    type: 'line',
                    name: '需求量',
                    smooth: true
                },{
                    data: data.data1,
                    type: 'line',
                    name: '服务量',
                    smooth: true
                }]
            }
            myChart.setOption(option)
            myChart.resize()
        }
    },
    watch: {
        chartData() {
            this.initChart()
        }
    }
}
</script>

<style scoped>
.lineChart {
    height: 100%;
}
</style>